import React from 'react'
import { Row, FormControl, InputGroup } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

export default class SearchBar extends React.Component {

  constructor() {
    super()
    this.state = { query: undefined }
  }

  componentDidMount() {
    this.setState({query: this.props.value})
  }

  onChange(e) {
    this.setState({query: e.target.value})
  }

  submit(e) {
    e.preventDefault()
    this.props.callback(this.state.query)
  }

  render() {
    return <Row>
      <div className="search">
        <form onSubmit={this.submit.bind(this)}>
          <InputGroup>
            <FormControl 
              type='text' 
              autoFocus={true} 
              defaultValue={this.props.value} 
              placeholder={ this.props.placeholder } 
              onChange={(e) => this.onChange(e)} 
            />
            <InputGroup.Button type='submit'>
              <button type='submit' className='btn-search btn btn-default'>
                <FontAwesome name='search' size='lg' />
              </button>
            </InputGroup.Button>
          </InputGroup>
        </form>
      </div>
    </Row>
  }
}
